export const configuration = {
  serviceUrls: {
    livesite: 'https://livesite.jetstream.vpsvc.com/',
    msx: 'https://merchandising-site-experience.prod.merch.vpsvc.com/api/',
    merchantProductOrchestration: 'https://merchant-orchestration-api.products.cimpress.io/',
    ranchService: 'https://ranch-cdn.products.cimpress.io/',
    logoRendering: 'https://logo-rendering.large-assortment.vpsvc.com/',
    productSurfaces: 'https://surfaces.products.vpsvc.com/',
    purcs: 'https://purcs.design.vpsvc.com/api/',
    lookupPreview: 'https://lookup.previews.cimpress.io/',
    docAssets: 'https://assets.documents.cimpress.io/',
  },
  requestor: 'bulma-pdp-herocarousel-fragment',
  mcpAuth: {
    mcpClientId: process.env.MCP_CLIENT_ID,
    mcpClientSecret: process.env.MCP_CLIENT_SECRET,
  },
  // TODO: Review this whenever multi-tenancy is implemented.
  vistaprintAccountId: 'ozoDdrmewShEcbUDWX8J3V',
  redis: {
    host: process.env.REDIS_HOST!,
    port: parseInt(process.env.REDIS_PORT!),
  },
};
